import { BGStatusType } from '../../../app/shared/Enums/BGStatusType';
import { CarrierTrackingPreference } from './FUMCarrier';
import { FUMEnterprise } from './FUMEnterprise';

export class FUMNewCarrier {
  carrierID: number;
  carrierName: string;
  carrierDbaName: string;
  carrierCode: string;
  customerName: string;
  isPay: boolean;
  status: BGStatusType;
  trackingPreference: CarrierTrackingPreference;
  mainAddress: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateProvince: string;
    postalCode: string;
    type: string;
    countryCode: string;
  };
  stateID: string;
  stateIDType: string;
  dotNumber: string;
  mcNumber: string;
  scac: string;
  enterprises: FUMEnterprise[];

  constructor(data: any) {
    this.carrierName = data.legalName;
    this.carrierDbaName = data.dbaName;
    this.customerName = data.customerName;
    this.status = BGStatusType.Pending;
    this.mainAddress = {
      addressLine1: data.addressLine1,
      addressLine2: data.addressLine2,
      city: data.city,
      stateProvince: data.state,
      postalCode: data.postalCode,
      type: 'Main',
      countryCode: data.countryCode
    };
    this.stateID = data.stateID;
    this.stateIDType = data.stateIDType;
    this.dotNumber = data.dotNumber;
    this.mcNumber = data.mcNumber;
    this.scac = data.scac;
    this.enterprises = data.enterprises;
    this.trackingPreference = CarrierTrackingPreference.MANUAL;
  }
}
